import React, { useEffect, useMemo, useState } from "react";
import { Container, Row, Col, Card, Button, Image } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import clicksims from "../../assets/img/clicksims.png";
import { useWhitelabel } from "../../contexts/WhitelabelContext";
import { useSelector } from "react-redux";

const SimsIntroduction = () => {
  const { t } = useTranslation();
  const { backgroundColor, fontColor, whitelabelUrl } = useWhitelabel();
  const { user } = useSelector((state) => state.user);
  const { impersonationUser } = useSelector((state) => state.impersonationUser);
  const [activeUser, setActiveUser] = useState({});

  useEffect(() => {
    setActiveUser(impersonationUser.id ? impersonationUser : user);
  }, [user, impersonationUser]);

  // Fallback to "ClickSims" if domainCompany is missing
  const brand = useMemo(
    () => activeUser?.domainCompany?.trim() || "ClickSims",
    [activeUser?.domainCompany]
  );

  return (
    <Container fluid className="sims-intro py-5">
      <Row className="justify-content-center">
        <Col lg={8}>
          <Card className="shadow-sm border-0 rounded-lg p-4">
            <Card.Body>
              <div className="text-center">
                <Image
                  width={200}
                  height={200}
                  src={whitelabelUrl ?? clicksims}
                  className="mb-4"
                />
              </div>
              <Card.Title className="display-6 mb-3">
                {t("documentation.simCards.introduction.title")}
              </Card.Title>
              <Card.Text className="lead">
                {t("documentation.simCards.introduction.description", {
                  brand,
                })}
              </Card.Text>
              <Card.Text>
                {t("documentation.simCards.introduction.details")}
              </Card.Text>
              <div className="text-center">
                <Button
                  variant="primary"
                  className="mt-3"
                  style={{
                    "--dynamic-bg-color": backgroundColor,
                    "--dynamic-font-color": fontColor,
                    border: "none",
                  }}
                >
                  {t("documentation.simCards.introduction.getStarted")}
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default SimsIntroduction;
